export default __webpack_public_path__ + "static/media/plenty_logo_white.9eed3630.png";